module.exports = __webpack_public_path__ + "static/img/areaB_9.1f6d20c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_9.png
// module id = 1272
// module chunks = 1